import PreviewUpload from './PreviewUpload'

export default PreviewUpload